import { ICellRendererParams } from 'ag-grid-community';

import { GoogleFontIcon } from '../../icons/GoogleFontIcon';
import { EMPTY_VALUE } from '../valueFormatters';

import { DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED } from './constants';

import styles from './detailPageCellRenderer.module.scss';

export type DetailPageCellRenderProps = ICellRendererParams & {
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export const DetailPageCellRenderer = ({
  formatValue,
  onClick,
  value,
  valueFormatted,
}: DetailPageCellRenderProps) => {
  if (value === undefined) {
    return;
  }

  if (value == null) {
    return formatValue?.(value) ?? EMPTY_VALUE;
  }

  const cellValue = valueFormatted ?? value;

  return (
    <div
      {...DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED}
      className={styles['root']}
      onClick={onClick}
      data-testid="detail-page-cell"
    >
      <span className={styles['value']}>{cellValue}</span>
      <GoogleFontIcon name="chevron_right" solid className={styles['icon']} />
    </div>
  );
};
